'use strict'
import $ from 'jquery'
import DirectoryService from '../endpoints/DirectoryService'
import ChangeRequestHelper from './ChangeRequestHelper'
import ChangeRequestService from '../endpoints/ChangeRequestService'
import FormValidationMixIn from '../components/FormValidationMixIn'
import VueFormHelper from '../common/VueFormHelper'
import Notifier from '../common/Notifier'
import MemberOrgService from '../endpoints/MemberOrgService'
import moment from 'moment'
import MaskedInput from 'vue-masked-input/dist/maskedInput'

const params = VueFormHelper.getRequestParameters(window.location.search.substring(1))

export default {
  mixins: [FormValidationMixIn],
  data () {
    return {
      changeRequest: {},
      listType: {
        id: '',
        description: ''
      },
      returnTo: '',
      step: 1
    }
  },
  components: {
    'masked-input': MaskedInput
  },
  computed: {
    listUrl: function () {
      return DirectoryService.getMemberListEndPoint() + '?type=' + this.listType.id
    },
    requestStatus: function () {
      return this.changeRequest.status ? ChangeRequestHelper.renderStatusDescription(this.changeRequest.status) : ''
    },
    isFutureDate: function () {
      if (this.changeRequest.effectiveDate) {
        let effectiveDate = moment(this.changeRequest.effectiveDate, 'MM/DD/YYYY')
        return effectiveDate > moment()
      }

      return false
    }
  },
  methods: {
    parentApproveChangeRequest: function (data) {
      this.clearErrors()
      if (!this.isFormDirty()) {
        this.onError('There are no changes to approve.  Please enter updated information prior to submission.')
        $('#approve-modal').modal('hide')
        return
      }

      ChangeRequestService.approveChangeRequest(data, this.changeRequest.requestTypeCode)
        .then(response => {
          this.saveResponse = response.data
          if (this.saveResponse.result === 'success') {
            this.changeRequest.status = 'A'
            this.returnTo = 'list'
          }
          $('#approve-modal').modal('hide')
        })
        .catch(error => {
          console.log(error.stack)
          this.onError('An unexpected error occurred approving change request.')
          $('#approve-modal').modal('hide')
        })
    },
    denyChangeRequest: function () {
      this.clearErrors()

      ChangeRequestService.denyChangeRequest(this.changeRequest)
        .then(response => {
          this.saveResponse = response.data
          if (this.saveResponse.result === 'success') {
            this.changeRequest.status = 'D'
            this.returnTo = 'list'
          }
        })
        .catch(error => {
          console.log(error.stack)
          this.onError('An unexpected error occurred denying change request.')
        })
    },
    cancelChangeRequest: function () {
      this.clearErrors()

      let params = {'id': this.changeRequest.id}
      ChangeRequestService.cancelChangeRequest(params)
        .then(response => {
          this.changeRequest.status = 'C'
          this.returnTo = 'list'
          this.saveResponse = response.data
        })
        .catch(error => {
          console.log(error.stack)
          this.onError('An unexpected error occurred cancelling change request.')
        })
    },
    parentSaveFutureChangeRequest: function (data) {
      this.clearErrors()

      ChangeRequestService.saveFutureChangeRequest(data, this.changeRequest.requestTypeCode)
        .then(response => {
          this.saveResponse = response.data
          if (this.saveResponse.result === 'success') {
            this.changeRequest.status = 'F'
            this.returnTo = 'stay-future'
          }
        })
        .catch(error => {
          console.log(error.stack)
          this.onError('An unexpected error occurred saving change request for future action.')
        })
    },
    loadDefaultOrgAddress: function () {
      MemberOrgService.loadOrgAddress(this.changeRequest.orgId)
        .then(response => {
          let address = response.data
          this.changeRequest.address1 = address.address1
          this.changeRequest.address2 = address.address2
          this.changeRequest.city = address.city
          this.changeRequest.state = address.state
          this.changeRequest.postalCode = address.postalCode
        })
        .catch(error => {
          console.log(error.stack)
          // fail silently
        })
    },
    onSuccess: function () {
      if (this.step === 1) {
        this.step = 2
        return
      }

      let currentUrl = window.location.href
      if (this.returnTo === 'close-window') {
        window.close()
      } else if (this.returnTo === 'list' && currentUrl.indexOf('admin') > 0) {
        window.location.href = ChangeRequestService.getAdminListEndPoint() + '?success=' + this.changeRequest.status
      } else if (this.returnTo === 'list') {
        window.location.href = ChangeRequestService.getListEndPoint() + '?success=' + this.changeRequest.status
      } else if (this.returnTo === 'org-detail') {
        let successParam = this.saveResponse.result === 'approved' ? 'A' : 'Y'
        window.location.href = DirectoryService.getOrgDetailEndPoint() + '?id=' + params['orgId'] + '&success=' + successParam
      } else if (this.returnTo === 'stay-future') {
        Notifier.success('Change Request has been saved for future approval.')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/directory/ChangeRequestParent.js